import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';

const columns = [
  {
    title: 'Number',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Internal Reference',
    dataIndex: 'internal_reference',
    key: 'internal_reference',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/lots-serial-numbers/'+record.number}>
        EDIT
      </Link>
    )
  }
]



const LotSerialNumbers = () => {
  const lotSerialNumbers = useLoaderData();
  
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Lots Serial Numbers</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/inventory/lots-serial-numbers/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        dataSource={lotSerialNumbers}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'number'}
      />
    
    </div>
  )
}

export default LotSerialNumbers;